import React from "react";

function RatingReview({
  rating,
  setRating,
  fontSize = 35,
}: {
  rating: number;
  setRating: any;
  fontSize?: number;
}) {
  return (
    <div>
      {[1, 2, 3, 4, 5].map((star) => {
        return (
          <span
            className="start"
            key={star}
            style={{
              cursor: "pointer",
              color: rating >= star ? "gold" : "gray",
              fontSize: `${fontSize}px`,
            }}
            onClick={() => {
              setRating(star);
            }}
          >
            {" "}
            ★{" "}
          </span>
        );
      })}
    </div>
  );
}

export default RatingReview;
